// Deterministic UK-safe outdoor stock imagery for locations that don't have their own cover photo yet.
// Free Unsplash photos — UK-friendly countryside / hiking / camping / forest / coast / dogs.
// Curated: removed the camper-van-in-desert, Patagonia hikers, baobab and banyan images from the hiking pool,
// and the desert tent from the camping pool.
const STOCK_HIKING = [
  "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&q=70",
  "https://images.unsplash.com/photo-1455156218388-5e61b526818b?w=1200&q=70",
  "https://images.unsplash.com/photo-1465056836041-7f43ac27dcb5?w=1200&q=70",
  "https://images.unsplash.com/photo-1500534314209-a25ddb2bd429?w=1200&q=70",
  "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?w=1200&q=70",
  "https://images.unsplash.com/photo-1486870591958-9b9d0d1dda99?w=1200&q=70",
  "https://images.unsplash.com/photo-1485470733090-0aae1788d5af?w=1200&q=70",
  "https://images.unsplash.com/photo-1448375240586-882707db888b?w=1200&q=70",
];
const STOCK_CAMPING = [
  "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=1200&q=70",
  "https://images.unsplash.com/photo-1487730116645-74489c95b41b?w=1200&q=70",
  "https://images.unsplash.com/photo-1517824806704-9040b037703b?w=1200&q=70",
  "https://images.unsplash.com/photo-1455496231601-e6195da1f841?w=1200&q=70",
  "https://images.unsplash.com/photo-1504851149312-7a075b496cc7?w=1200&q=70",
  "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?w=1200&q=70",
  "https://images.unsplash.com/photo-1414016642750-7fdd78dc33d9?w=1200&q=70",
];

function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
}

export function stockImageFor(location) {
  if (!location) return STOCK_HIKING[0];
  const pool = location.type === "camping" ? STOCK_CAMPING : STOCK_HIKING;
  const key = location.location_id || location.name || "trail";
  return pool[hashString(key) % pool.length];
}

export function coverImageFor(location) {
  if (location?.cover_image) return location.cover_image;
  // user-submitted photos win over stock
  if (location?.user_photos?.length) return location.user_photos[0];
  return stockImageFor(location);
}

// True when the cover shown for this location is a stock/fallback image
// (i.e. no real cover_image and no user_photos yet). Used by UI to mark
// the image with a small "Sample photo" tag and show the "Add yours" link
// on the trail page.
export function isFallbackImage(location) {
  if (!location) return true;
  if (location.cover_image) return false;
  if (location.user_photos?.length) return false;
  return true;
}
